
import Navigation from '../../../components/feature/Navigation';
import Footer from '../../../components/feature/Footer';
import AreaHero from '../components/AreaHero';
import AreaServices from '../components/AreaServices';
import AreaTestimonials from '../components/AreaTestimonials';
import AreaCTA from '../components/AreaCTA';
import { useSEO, generateAreaPageSchema, generateBreadcrumbSchema } from '../../../utils/seo';

export default function PinnerPage() {
  const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

  useSEO({
    title: 'Painters & Decorators Pinner Greater London | Brushour',
    description: 'Trusted painting and decorating services in Pinner, Greater London. Covering Pinner Village, Pinner Green, and Hatch End. Fully insured, 18+ years experience. Free quotes available.',
    keywords: 'painters Pinner, decorators Pinner London, painting services Pinner Green, Pinner painters decorators, decorating Hatch End',
    canonical: `${SITE_URL}/areas/pinner`,
    schema: [
      generateAreaPageSchema('Pinner', 'Greater London', 'pinner', 51.5933, -0.3803, 'HA5'),
      generateBreadcrumbSchema([
        { name: 'Home', url: SITE_URL },
        { name: 'Areas', url: `${SITE_URL}/areas` },
        { name: 'Pinner', url: `${SITE_URL}/areas/pinner` },
      ]),
    ],
  });

  const areaData = {
    name: 'Pinner',
    region: 'Greater London',
    description: 'Trusted painting and decorating services in Pinner. Our experienced team provides top-quality interior and exterior painting, wallpapering, and decorative solutions for residential and commercial properties throughout Pinner.',
    heroImage: 'https://public.readdy.ai/ai/img_res/15cf57a19cdd87f59a50c79bae68a457.jpg',
    serviceAreas: ['Pinner Village', 'Pinner Green', 'Hatch End', 'Pinnerwood Park'],
  };

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <AreaHero data={areaData} />
      <AreaServices area="Pinner" />
      <AreaTestimonials area="Pinner" />
      <AreaCTA area="Pinner" />
      <Footer />
    </div>
  );
}
